import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tower-view-container" }
const _hoisted_2 = {
  key: 1,
  class: "tower-view-content"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "side-panel"
}
const _hoisted_5 = { class: "panel-header" }
const _hoisted_6 = { class: "panel-title" }
const _hoisted_7 = { class: "checkbox-label" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tip-header" }
const _hoisted_10 = { class: "tip-title" }
const _hoisted_11 = { class: "tip-content" }
const _hoisted_12 = {
  key: 0,
  class: "tip-row"
}
const _hoisted_13 = { class: "tip-text" }
const _hoisted_14 = { class: "tip-row" }
const _hoisted_15 = { class: "tip-text" }
const _hoisted_16 = { class: "tip-row" }
const _hoisted_17 = { class: "tip-text" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "image-preview-overlay"
}
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "header-right" }
const _hoisted_22 = ["src"]

import {
  ref,
  computed,
  onMounted,
  getCurrentInstance,
  onBeforeMount,
  reactive,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { $enum, $config } from "@/global/index";
import useLoading3D from "@/hooks/useLoading3D";
import useReceiveMessage from "@/hooks/useReceiveMessage";
import ReviewHeader from "@/components/modules/reviewHeader/index.vue";
import {
  enterOrExitDeviceStudyModule,
  resetDeviceStudyView,
  switchDeviceStudyMode,
  selectModel,
  disassembleModel,
  restoreModel,
  showOrHideAirLine,
} from "@/webapi/index";
enum PageName {
  加载中 = 1,
  查看 = 2,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'tower-view',
  setup(__props) {

const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance()!;

const typeMap = new Map([
  ["notifyRunningParam", "notifyRunningParam"], //运行数据回调
  ["loadResourceFail", "loadResourceFail"], //加载模型失败
  ["loadSceneResource", "loadSceneResource"], //加载模型完成
  ["modelLoading", "modelLoading"], //加载模型进度
  ["initializeEngineProgress", "initializeEngineProgress"], //引擎初始化
  ["notifyReferenceImage", "notifyReferenceImage"], //参考图片回调
  ["notifyPhotoNotPass", "notifyPhotoNotPass"], //图片不合格
  ["notifyActionEvaluateParams", "notifyActionEvaluateParams"], // 画面占比标准值
  ["extraLoadModelFiles", "extraLoadModelFiles"], //额外的模型文件列表
  ["notifyDeviceStudySelectedScreenPos", "notifyDeviceStudySelectedScreenPos"], //设备选择点位回调
]);

const state = reactive({
  title:
    store.state.persistence.towerIdentify.sceneInfo?.sceneSubTypeName || "",
  currentPage: PageName.加载中,
  sceneImage:
    $config.FILE_ROOT_PATH +
    (store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
      ?.scenePictureUrl || ""),
  resourceFileList:
    store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
      ?.resourceFileList || [],
  stationdId:
    store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
      ?.stationId || null,
  loading3D: {
    title:
      store.state.persistence.towerIdentify.sceneInfo?.sceneSubTypeName || "",
    description:
      store.state.persistence.towerIdentify.sceneInfo?.typeDescription || "",
    pageType: "认识",
  },
  engineProgress: 0,
  panelItemIndex: -1,
  firstPointPos: {
    x: 0,
    y: 0,
  },
});
const showTipPanel = ref(false);
const connectionCanvas = ref<HTMLCanvasElement | null>(null);
let canvasCtx: CanvasRenderingContext2D | null = null;
const resourceFileList =
  store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
    ?.resourceFileList;
let fileTypeList = ["Materials", "Models", "Nodes", "Textures", "Animations"];
let specifyModelFiles = [];
for (let item of resourceFileList) {
  for (let childeItem of item) {
    if (fileTypeList.includes(childeItem?.fileName)) {
      specifyModelFiles.push(childeItem);
    }
  }
}

const {
  loadingState,
  setLoadingStatus,
  engineInitialized,
  handleOpenPDF,
  setExtraFileMap,
  showOrHideEngineView,
} = useLoading3D(state.stationdId, specifyModelFiles, proxy);

const loadingProgess = computed(() => {
  if (engineInitialized.value) {
    return loadingState.progressValue;
  } else {
    return (state.engineProgress * 100).toFixed(2);
  }
});

const activeTabEnum = {
  恢复默认: 0,
  设备组成: 1,
  设备点位: 2,
};

const activeTab = ref<number>(activeTabEnum.恢复默认);
const decomposeChecked = ref(false);
const inspectionChecked = ref(false);
const tipPanel = ref<HTMLDivElement | null>(null);
const selectedItem = ref<any>(null);

// 图片预览
const previewVisible = ref(false);
const previewImageUrl = ref('');

const currentPanel = computed(() => {
  const towerIdentify = store.state.persistence.towerIdentify;
  if (activeTab.value === activeTabEnum.设备组成) {
    const panel = {
      title: "设备重要部件",
      checkboxLabel: "分解设备",
      checked: decomposeChecked.value,
      toggle: decomposeToggle,
      items: towerIdentify.deviceDetail?.parts || [],
    };
    return panel;
  } else {
    const panel = {
      title: "设备巡检点位",
      checkboxLabel: "显示巡检路径",
      checked: inspectionChecked.value,
      toggle: inspectionToggle,
      items: towerIdentify.airlineDetail?.pointList || [],
    };
    return panel;
  }
});

watch(
  () => showTipPanel.value,
  (newVal) => {
    if (!newVal) {
      state.firstPointPos = {
        x: 0,
        y: 0,
      };
      canvasCtx.clearRect(
        0,
        0,
        connectionCanvas.value.width,
        connectionCanvas.value.height
      );
    }
  }
);

useReceiveMessage(typeMap, (type: string, data: any) => {
  if (type === "loadSceneResource") {
    state.currentPage = PageName.查看;
    enterOrExitDeviceStudyModule({
      enter: true,
      modelName:
        store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
          ?.modelName,
      sceneTypeId:
        store.state.persistence.towerIdentify.sceneInfo?.sceneTypeId,
      airlinePointList:
        store.state.persistence.towerIdentify.airlineDetail?.pointList || [],
      devicePartList:
        store.state.persistence.towerIdentify.deviceDetail?.parts || [],
      transitionPointList:
        store.state.persistence.towerIdentify.airlineDetail?.transitionPointList || [],
    });
    nextTick(() => {
      handleResize();
    });
  }

  if (type === "modelLoading") {
    setLoadingStatus(data.data);
  }

  if (type === "extraLoadModelFiles") {
    setExtraFileMap(data.data);
  }

  if (type === "initializeEngineProgress") {
    state.engineProgress = data.data?.progress || 0;
  }

  if (type === "notifyDeviceStudySelectedScreenPos") {
    if (
      data.data &&
      (data.data?.x != state.firstPointPos?.x ||
        data.data?.y != state.firstPointPos?.y)
    ) {
      state.firstPointPos = data.data;
      if (showTipPanel.value) {
        drawConnection(data.data?.x, data.data?.y);
      }
    }
  }
});

const inspectionToggle = () => {
  inspectionChecked.value = !inspectionChecked.value;
  showOrHideAirLine({
    show: inspectionChecked.value,
  });
};

const decomposeToggle = () => {
  decomposeChecked.value = !decomposeChecked.value;
  if (decomposeChecked.value) {
    //拆解
    disassembleModel({
      modelName:
        store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
          ?.modelName,
    });
  } else {
    //恢复
    restoreModel({
      modelName:
        store.state.persistence.towerIdentify.sceneInfo?.stationList[0]
          ?.modelName,
    });
  }
};

const handleBack = () => {
  window?.playClick();
  if (store.state.viewData.enterScene) {
    showOrHideEngineView(false);
    store.commit("viewData/setEnterScene", false);
  }
  router.back();
};

const handleActiveTab = (tab: number) => {
  if (tab == activeTab.value) {
    //恢复默认
    activeTab.value = activeTabEnum.恢复默认;
  } else {
    //切换tab
    activeTab.value = tab;
  }
  showTipPanel.value = false;
  decomposeChecked.value = false;
  inspectionChecked.value = false;
  state.panelItemIndex = -1;
  switchDeviceStudyMode({
    mode: activeTab.value,
  });
};

const handleReset = () => {
  // 重置逻辑
  console.log("reset");
  resetDeviceStudyView();
};

const getReferenceImageUrl = (url: string) => {
  if (!url) return "";
  const base = (process.env as any).VUE_APP_FILE_URL || "";
  return base + url;
};

// 打开图片预览
const openPreview = (url: string) => {
  previewImageUrl.value = getReferenceImageUrl(url);
  previewVisible.value = true;
};

// 关闭图片预览
const closePreview = () => {
  previewVisible.value = false;
  previewImageUrl.value = "";
};

// 预览图片左右切换
const previewPrev = () => {
  if (!selectedItem.value || activeTab.value !== activeTabEnum.设备点位) return;
  const items = currentPanel.value?.items || [];
  const currentIdx = state.panelItemIndex;
  if (currentIdx <= 0 || items.length === 0) return;

  const prevIdx = currentIdx - 1;
  const prevItem = items[prevIdx];
  selectItem(prevItem, prevIdx);

  // 更新预览图片地址
  if (prevItem?.referenceUrl) {
    previewImageUrl.value = getReferenceImageUrl(prevItem.referenceUrl);
  }
};

const previewNext = () => {
  if (!selectedItem.value || activeTab.value !== activeTabEnum.设备点位) return;
  const items = currentPanel.value?.items || [];
  const currentIdx = state.panelItemIndex;
  if (currentIdx >= items.length - 1 || items.length === 0) return;

  const nextIdx = currentIdx + 1;
  const nextItem = items[nextIdx];
  selectItem(nextItem, nextIdx);

  // 更新预览图片地址
  if (nextItem?.referenceUrl) {
    previewImageUrl.value = getReferenceImageUrl(nextItem.referenceUrl);
  }
};

const selectItem = (item: any, index: number) => {
  let data = null;
  if (state.panelItemIndex != index) {
    state.panelItemIndex = index;
    selectedItem.value = item;
    if (!showTipPanel.value) {
      showTipPanel.value = true;
    }
  } else {
    state.panelItemIndex = -1;
    showTipPanel.value = false;
    selectedItem.value = null;
  }
  if (activeTab.value == activeTabEnum.设备组成 && state.panelItemIndex != -1) {
    data = {
      id: item.id,
    };
  } else if (
    activeTab.value == activeTabEnum.设备点位 &&
    state.panelItemIndex != -1
  ) {
    data = {
      id: item.pointId,
    };
  }
  selectModel(data || {});
  console.log("select item:", item);
};

// ==================== 连线功能 ====================

// 初始化 Canvas
const initCanvas = () => {
  if (!connectionCanvas.value) return;
  const canvas = connectionCanvas.value;
  // Canvas 是 fixed 全屏，尺寸 = 视口尺寸
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  canvasCtx = canvas.getContext("2d");
};

// 绘制连线（两段直线）
const drawConnection = (viewportX: number, viewportY: number) => {
  if (!canvasCtx || !connectionCanvas.value) return;

  // 因为 Canvas 是 fixed 全屏，视口坐标 = Canvas 坐标
  const startX = viewportX;
  const startY = viewportY;

  // 计算终点（提示面板右边 + 顶部 60px）
  const panel = tipPanel.value as HTMLDivElement | null;
  if (!panel) return;

  const panelRect = panel.getBoundingClientRect();
  const endX = panelRect.left + panelRect.width;
  const endY = panelRect.top + panelRect.height * 0.3;

  // 计算中间点（y = endY，x = startX + (endX - startX) / 1.7）
  const midX = startX + (endX - startX) / 1.7;
  const midY = endY;

  // 清空并绘制
  canvasCtx.clearRect(
    0,
    0,
    connectionCanvas.value.width,
    connectionCanvas.value.height
  );

  // 在起点绘制白色圆形（半径 8px）
  canvasCtx.fillStyle = "#FFFFFF";
  canvasCtx.beginPath();
  canvasCtx.arc(startX, startY, 4, 0, Math.PI * 2);
  canvasCtx.fill();

  // 绘制白色连线
  canvasCtx.strokeStyle = "#FFFFFF";
  canvasCtx.lineWidth = 1.5;

  // 第一段直线：起点 → 中间点
  canvasCtx.beginPath();
  canvasCtx.moveTo(startX, startY);
  canvasCtx.lineTo(midX, midY);
  canvasCtx.stroke();

  // 第二段直线：中间点 → 终点
  canvasCtx.beginPath();
  canvasCtx.moveTo(midX, midY);
  canvasCtx.lineTo(endX, endY);
  canvasCtx.stroke();
};

// 窗口 resize 时重新初始化 Canvas 尺寸
const handleResize = () => {
  initCanvas();
  // 如果面板已显示，重新绘制（使用假坐标）
  if (showTipPanel.value) {
    // 假坐标：页面中央偏上
    drawConnection(state.firstPointPos?.x, state.firstPointPos?.y);
  }
};

function handleBeforeUnload(e: BeforeUnloadEvent) {
  if (store.state.viewData.enterScene) {
    store.commit("viewData/setEnterScene", false);
  }
}

////////////////////////////////////////////////// 生命周期
onBeforeMount(() => {
  if (!store.state.viewData.enterScene) {
    showOrHideEngineView(true);
    store.commit("viewData/setEnterScene", true);
  }
});

onMounted(() => {
  window.addEventListener("beforeunload", handleBeforeUnload);

  // 监听窗口 resize
  window.addEventListener("resize", handleResize);
});
onBeforeUnmount(() => {
  enterOrExitDeviceStudyModule({
    enter: false,
  });
  window.removeEventListener("beforeunload", handleBeforeUnload);
  // 移除窗口 resize 监听
  window.removeEventListener("resize", handleResize);
  if (store.state.viewData.enterScene) {
    showOrHideEngineView(false);
    store.commit("viewData/setEnterScene", false);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_vkm_loading3D = _resolveComponent("vkm-loading3D")!
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.currentPage == PageName.加载中)
      ? (_openBlock(), _createBlock(_component_vkm_loading3D, {
          key: 0,
          engineInitialized: _unref(engineInitialized),
          sceneImage: state.sceneImage,
          receive: _unref(loadingState).receive,
          sum: _unref(loadingState).sum,
          speed: _unref(loadingState).speed,
          currentFile: _unref(loadingState).currentFile,
          maxFile: _unref(loadingState).maxFile,
          progressValue: loadingProgess.value,
          title: state.loading3D.title,
          description: state.loading3D.description,
          pageType: state.loading3D.pageType
        }, null, 8, ["engineInitialized", "sceneImage", "receive", "sum", "speed", "currentFile", "maxFile", "progressValue", "title", "description", "pageType"]))
      : _createCommentVNode("", true),
    (state.currentPage == PageName.查看)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ReviewHeader, {
            class: "tower-view-header",
            useDefaultLeft: false
          }, {
            left: _withCtx(() => [
              _createVNode(_component_vkm_svg, {
                "icon-name": "back",
                class: "icon",
                onClick: handleBack
              }),
              _createElementVNode("p", _hoisted_3, _toDisplayString(state.title), 1)
            ]),
            center: _withCtx(() => [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-btn", { primary: activeTab.value === activeTabEnum.设备组成 }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleActiveTab(activeTabEnum.设备组成)))
              }, " 设备组成 ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["nav-btn", { primary: activeTab.value === activeTabEnum.设备点位 }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleActiveTab(activeTabEnum.设备点位)))
              }, " 设备点位 ", 2)
            ]),
            right: _withCtx(() => [
              _createElementVNode("div", {
                class: "reset-btn",
                onClick: handleReset
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "iconfont-line vk_sx_line1" }, null, -1)
              ]))
            ]),
            _: 1
          }),
          (
          activeTab.value == activeTabEnum.设备组成 ||
          activeTab.value == activeTabEnum.设备点位
        )
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(currentPanel.value?.title), 1),
                  _createElementVNode("div", {
                    class: "checkbox-wrapper",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (currentPanel.value?.toggle()))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["custom-checkbox", {
                unchecked: !currentPanel.value?.checked,
                checked: currentPanel.value?.checked,
              }])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(currentPanel.value?.checkboxLabel), 1)
                  ])
                ]),
                _createVNode(_component_el_scrollbar, { class: "panel-list" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentPanel.value?.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["list-item", { active: index === state.panelItemIndex }]),
                        onClick: ($event: any) => (selectItem(item, index))
                      }, _toDisplayString(activeTab.value == activeTabEnum.设备组成
                ? item?.partName
                : `${index + 1}.${item?.actionName}`), 11, _hoisted_8))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("canvas", {
            ref_key: "connectionCanvas",
            ref: connectionCanvas,
            class: "connection-canvas"
          }, null, 512),
          _withDirectives(_createElementVNode("div", {
            ref_key: "tipPanel",
            ref: tipPanel,
            class: "tip-panel-container"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(activeTab.value === activeTabEnum.设备组成
                ? selectedItem.value?.partName
                : selectedItem.value?.actionName), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              (activeTab.value === activeTabEnum.设备组成 && selectedItem.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "bullet" }, null, -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(selectedItem.value.description), 1)
                  ]))
                : (activeTab.value === activeTabEnum.设备点位 && selectedItem.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bullet" }, null, -1)),
                        _createElementVNode("div", _hoisted_15, " 拍摄角度: " + _toDisplayString(selectedItem.value.shootAngle), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "bullet" }, null, -1)),
                        _createElementVNode("div", _hoisted_17, " 拍摄要求: " + _toDisplayString(selectedItem.value.shootRequirement), 1)
                      ]),
                      (selectedItem.value.referenceUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "reference-image-wrapper",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (openPreview(selectedItem.value.referenceUrl)), ["stop"]))
                          }, [
                            _createElementVNode("img", {
                              src: getReferenceImageUrl(selectedItem.value.referenceUrl),
                              class: "reference-image",
                              alt: "参考图"
                            }, null, 8, _hoisted_18)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, showTipPanel.value]
          ]),
          (previewVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", {
                  class: "image-preview-header",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(selectedItem.value?.actionName || ''), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: "reset-btn",
                      onClick: _withModifiers(closePreview, ["stop"])
                    }, _cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "iconfont-line vk_gb_line1" }, null, -1)
                    ]))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "image-preview-content",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (activeTab.value === activeTabEnum.设备点位 && currentPanel.value?.items?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["preview-arrow left", { disabled: state.panelItemIndex === 0 }])
                      }, [
                        _createElementVNode("div", {
                          class: "reset-btn",
                          onClick: _withModifiers(previewPrev, ["stop"])
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "iconfont-line vk_djtz_line" }, null, -1)
                        ]))
                      ], 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("img", {
                    src: previewImageUrl.value,
                    class: "image-preview-img",
                    alt: "预览图"
                  }, null, 8, _hoisted_22),
                  (activeTab.value === activeTabEnum.设备点位 && currentPanel.value?.items?.length > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["preview-arrow right", { disabled: state.panelItemIndex === (currentPanel.value?.items?.length || 0) - 1 }])
                      }, [
                        _createElementVNode("div", {
                          class: "reset-btn",
                          onClick: _withModifiers(previewNext, ["stop"])
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "iconfont-line vk_djty_line" }, null, -1)
                        ]))
                      ], 2))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})